import { checkWithMediumJson } from './checkWithMediumJson';

/**
 * ตรวจสอบค่า ไตรกลีเซอไรด์ โดยใช้ค่าปกติจาก medium.json
 */
export default async (value, age, gender) => {
  return await checkWithMediumJson(value, 'ไตรกลีเซอไรด์', gender, age, 'ไตรกลีเซอไรด์');
};
